import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const overlayStyle = {
  position: 'fixed',
  inset: 0,
  backgroundColor: '#0B1F3F',
  zIndex: 99999,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  pointerEvents: 'none',
};

const innerStyle = {
  position: 'relative',
  width: '160px',
  height: '160px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const logoStyle = {
  position: 'relative',
  zIndex: 2,
  width: '88px',
  height: '88px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export default function PageTransition() {
  const location = useLocation();
  const [phase, setPhase] = useState('hidden'); // hidden | in | visible | out

  useEffect(() => {
    // Fade in
    setPhase('in');
    const showTimer = setTimeout(() => setPhase('visible'), 80);
    // Fade out after hold
    const hideTimer = setTimeout(() => setPhase('out'), 750);
    // Remove after fade out
    const doneTimer = setTimeout(() => setPhase('hidden'), 1050);
    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
      clearTimeout(doneTimer);
    };
  }, [location.pathname]);

  if (phase === 'hidden') return null;

  const opacity = phase === 'in' ? 0 : phase === 'visible' ? 1 : 0;

  return (
    <div
      style={{
        ...overlayStyle,
        opacity,
        transition: phase === 'out' ? 'opacity 0.3s ease' : 'opacity 0.12s ease',
      }}
    >
      {/* Ripple ring behind logo */}
      <div
        style={{
          position: 'absolute',
          width: '110px',
          height: '110px',
          borderRadius: '50%',
          border: '1px solid rgba(0,165,181,0.25)',
          animation: 'mgt-ripple 1.8s ease-out infinite',
        }}
      />

      <div style={innerStyle}>
        {/* Spinning teal arc — brand color #00A5B5 */}
        <svg
          style={{
            position: 'absolute',
            inset: 0,
            width: '160px',
            height: '160px',
            animation: 'mgt-spin 1.4s linear infinite',
            filter: 'drop-shadow(0 0 8px rgba(0,165,181,0.7))',
          }}
          viewBox="0 0 160 160"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="80"
            cy="80"
            r="70"
            fill="none"
            stroke="#00A5B5"
            strokeWidth="3"
            strokeDasharray="270 170"
            strokeLinecap="round"
          />
        </svg>

        {/* Magizhini Tech logo */}
        <div style={logoStyle}>
          <img
            src="banner-logo.png"
            alt="Magizhini Tech"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              animation: 'mgt-pulse 1s ease-in-out infinite alternate',
              filter:
                'drop-shadow(0 0 6px rgba(0,165,181,0.6)) drop-shadow(0 0 14px rgba(0,165,181,0.25))',
            }}
          />
        </div>
      </div>

      {/* Inline keyframes */}
      <style>{`
        @keyframes mgt-spin {
          from { transform: rotate(0deg); }
          to   { transform: rotate(360deg); }
        }
        @keyframes mgt-pulse {
          from { transform: scale(0.93); opacity: 0.88; }
          to   { transform: scale(1.05); opacity: 1; }
        }
        @keyframes mgt-ripple {
          0%   { transform: scale(0.85); opacity: 0.6; }
          100% { transform: scale(1.35); opacity: 0; }
        }
      `}</style>
    </div>
  );
}
